module.exports = __webpack_public_path__ + "80c8fd36048c3630a7e0b4c782ce0837.jpg";